export class ProxyArticle{
    constructor (id, titleA, textA, srvFileLink, type, link ){
        this.id = id
        this.titleA= titleA;
	    this.textA = textA;
	    this.srvFileLink = srvFileLink;
	    this.type=type;
	    this.link= link;
    }
}